import {
  BooleanInput,
  CreateContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  Title,
  useCreateController,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

export const GraduationCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "graduations/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <Title title="Formações" />
      {/* toolbar={false}: Salvar no topo, na linha do breadcrumb */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Formações"
          firstPath="/#/graduations/crud"
          secondTitle="Novo"
          actions={<SaveButton label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Criar Novo" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput
                  source="reviewed"
                  label="Revisada"
                  helperText="Formações revisadas aparecem primeiro nas listas de seleção do cadastro do sócio"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
